<template>
</template>
<script>

import AuthService from '@/services/AuthService';

export default {
  name: '',
  mounted() {
    this.$nextTick(() => {
      AuthService.setIdToken();
      window.location.href = '/';
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue